import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import dayjs from 'dayjs'

class TicketAlarm {
  constructor(init) {
    // console.log('> TicketAlarm constructor -', init)
    if (isNil(init)) return undefined
    this._datetime = init.datetime
    this._notes = init.notes
  }

  static shape = {
    datetime: PropTypes.string,
    notes: PropTypes.string
  }

  get datetime() {
    return this._datetime
  }

  get notes() {
    return this._notes
  }

  // Calculable
  get getDatetime() {
    return dayjs(this._datetime).format('MM-DD-YYYY аt hh:mm A')
  }

  get getDate() {
    return dayjs(this._datetime).format('MM/DD/YYYY')
  }
}

export default TicketAlarm
